import React from 'react';
import './Team.css';
import { FaLinkedin, FaTwitter, FaEnvelope, FaUserTie, FaUserCog, FaUserGraduate } from 'react-icons/fa';

const Team = () => {
  const teamMembers = [
    {
      name: 'Waqar Ahmad',
      position: 'Director',
      // description: 'With over 5 years of experience in recruitment and lead generation, Muhammad leads our team with a vision to transform how businesses connect with talent and opportunities globally.',
      icon: <FaUserTie />,
      linkedin: 'https://www.linkedin.com/in/iqbal-akhtar-374169390/',
      // twitter: '#',
      email: 'iqbal@leadstalentsourcingsolutions.com'
    },
    {
      name: 'Muhammad Iqbal Akhtar',
      position: 'Managing Director',
      // description: 'Sarah brings 8 years of experience in business development and operations management. She ensures our clients receive exceptional service and results across all projects.',
      icon: <FaUserTie />,
      linkedin: 'https://www.linkedin.com/in/iqbal-akhtar-374169390/',
      // twitter: '#',
      email: 'Iqbal@leadstalentsourcingsolutions.com'
    },
    {
      name: 'Ali Ahmad',
      position: 'Lead Sourcing Specialist',
      // description: 'David is our expert in candidate sourcing and lead generation strategies. With a background in data analytics, he delivers precision-targeted results for our clients.',
      icon: <FaUserTie />,
      linkedin: 'https://www.linkedin.com/in/iqbal-akhtar-374169390/',
      // twitter: '#',
      email: 'iqbal@leadstalentsourcingsolutions.com'
    }
  ];

  return (
    <section className="team section" id="team">
      <div className="container">
        <h2 className="section-title">Our Team</h2>
        <p className="section-subtitle">
          Meet the experts behind LTSS who are dedicated to your success.
        </p>

        <div className="team-grid">
          {teamMembers.map((member, index) => (
            <div className="team-card" key={index}>
              <div className="team-icon-wrapper">
                <div className="team-icon">
                  {member.icon}
                </div>
              </div>
              
              <div className="team-info">
                <h3 className="team-name">{member.name}</h3>
                <p className="team-position">{member.position}</p>
                <p className="team-description">{member.description}</p>
                
                <div className="team-social">
                  <a href={member.linkedin} target="_blank" rel="noopener noreferrer" className="team-social-link">
                    <FaLinkedin />
                  </a>
                  {/* <a href={member.twitter} target="_blank" rel="noopener noreferrer" className="team-social-link">
                    <FaTwitter />
                  </a> */}
                  <a href={`mailto:${member.email}`} className="team-social-link">
                    <FaEnvelope />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;